export enum PlatformEnum {
  KALSHI = "kalshi",
  LIMITLESS = "limitless",
  OPINION = "opinion",
  POLYMARKET = "polymarket",
  PREDICTION_FUN = "predict",
}

/**
 * The platform as it arrives on the wire — the string-literal union the OpenAPI
 * contract emits (`"kalshi" | "polymarket" | …`). Identical values to
 * `PlatformEnum`, but assignable from generated DTO fields (which are plain
 * string unions, not the nominal enum). Use this to type props/params that
 * consume `platforms` off a contract type.
 */
export type Platform = `${PlatformEnum}`;
